import { signalStore, withState } from '@ngrx/signals';
import { initialOrganizationState } from './organization.state';
import { withOrganizationApiMethods } from './organization.methods.api';

export const OrganizationStore = signalStore(
  { providedIn: 'root' },
  withState(initialOrganizationState),
  withOrganizationApiMethods
);
